var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"justify-center full-width",attrs:{"fluid":"","fill-height":""}},[_c('div',{staticStyle:{"width":"100%","height":"75vh","max-width":"800px"},attrs:{"id":"h5p-container-"+_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }